<template>
    <div class="block-grey">
        <div class="block-title">
            <slot name="block-title"></slot>
        </div>
        <div class="block-body">
            <slot name="block-body"></slot>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            
        }
    },
    props:{
    },
    methods: {
        
    }
}
</script>
<style lang="scss"  >
    .block-grey{
        position: relative;
        width: 100%;

        border-radius: 4px;
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        margin-bottom: 20px;

        >.block-title{
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #292625;
            padding: 16px;
            border-bottom: 1px solid #f3f3f3;
        }
        >.block-body{
            padding: 20px 44px 9px 44px;
        }
    }
    @media screen and (max-width: 1280px) {
        .block-grey{
            width: 1140px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/blockGrey.vue